import React from 'react';
import { HexColorPicker } from 'react-colorful';

import { usePageStore } from '@client/store/pageStore/context/pageContext';
import i18n from '@client/utils/i18n';
import { RecipeSection } from '@ledium/types';
import { invertColor } from '@ledium/ui-common';
import { Grid, Popover } from '@mui/material';
import InputLabel from '@mui/material/InputLabel';

interface SectionColorPickerProps {
    sectionData: RecipeSection;
    setSectionData: (data: RecipeSection) => void;
}

const SectionColorPicker = ({ setSectionData, sectionData }: SectionColorPickerProps) => {
    const {
        pageState: { formData }
    } = usePageStore();

    const [color, setColor] = React.useState('#FFFFFF');
    const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);

    React.useEffect(() => {
        setColor(sectionData.sectionColor?.background || '#FFFFFF');
    }, [sectionData.sectionColor]);

    function onColorChange(newColor: string) {
        setSectionData({
            ...sectionData,
            sectionColor: {
                background: newColor,
                text: invertColor(newColor)
            }
        });
        setColor(newColor);
    }

    return (
        <Grid item xs={4}>
            {formData.readOnly ? null : (
                <>
                    <InputLabel shrink>{i18n('select_section_background_color')}</InputLabel>
                    <button
                        data-testid="color-swatch"
                        type="button"
                        onClick={(e) => setAnchorEl(e.currentTarget)}
                        style={{
                            width: 32,
                            height: 32,
                            backgroundColor: color,
                            border: '1px solid rgba(0,0,0,0.23)',
                            borderRadius: 4,
                            cursor: 'pointer',
                            padding: 0
                        }}
                        aria-label={String(i18n('select_section_background_color'))}
                    />
                    <Popover
                        open={Boolean(anchorEl)}
                        anchorEl={anchorEl}
                        onClose={() => setAnchorEl(null)}
                        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                        transformOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                    >
                        <HexColorPicker color={color} onChange={onColorChange} />
                    </Popover>
                </>
            )}
        </Grid>
    );
};

export default SectionColorPicker;
